import {Component, OnInit, ComponentFactory, ComponentFactoryResolver, ComponentRef, ViewChild, ViewContainerRef} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

import {AppService} from '@api';

import {AlertaEnum} from "@mensaje/Enumeraciones/MensajeEnumeraciones.enum";
import {MensajeService} from "@mensaje/Mensaje.Service";
import {SistemaService} from '@servicios/Sistema.Service';
import {UsuarioService} from '@servicios/Usuario.service';
import {RespuestaEstatusEnum} from '@enumeraciones/Enumeraciones.enum';

import {AlumnoComponent} from '@contenido/AppContent/evaluacionpendiente/alumno/alumno.component';

@Component(
    {
        selector: 'evaluacionerp',
        templateUrl: './evaluacionerp.template.html',
        styleUrls: ['./evaluacionerp.component.scss']
    })

export class EvaluacionErpComponent implements OnInit {
    consulta!: boolean;
    dataTable!: Array<any>;
    dataTablebase!: Array<any>;
    listaalumno!: Array<any>;
    alumnoid: number = 0;
    verlista: boolean = false;
    @ViewChild("containerEvaluacion", {read: ViewContainerRef}) containerEvaluacion!: ViewContainerRef;


    constructor(private appService: AppService, private route: ActivatedRoute, public usuarioService: UsuarioService, private mensajeService: MensajeService, public sistemaService: SistemaService, public _cfr: ComponentFactoryResolver) {

    }


    ngOnInit() {
        this.sistemaService.datosInicialesCargados = true;
        let token = this.route.snapshot.paramMap.get('token');
        let data = {token: token};
        this.appService.Post("auth/loginexterno", data).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                localStorage.setItem(this.sistemaService.localStoreVariable.JWT, res.data.token);
                this.getLista()
            }
            else {

            }
        });
    }

    getLista() {
        this.appService.Get("evaluacionpendiente/erp").then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                let info = this.AgruparLista(res.data.evaluaciones);
                if(info.length > 1){
                    this.listaalumno = [];
                    this.dataTablebase = res.data.evaluaciones;
                    this.verlista = true;
                    this.listaalumno = info;
                    if(this.alumnoid != 0){
                        this.Filtro(this.alumnoid);
                    }
                }else{
                    this.dataTable = res.data.evaluaciones;
                }
            }
        })
    }

    Filtro(e:any){
       this.dataTable = this.dataTablebase.filter(x=>x.alumnoid == e);
    }


    AgruparLista(lista:any): any{

        let result = Array.from(lista.reduce((m:any, t:any) => m.set(t.alumnoid, t), new Map()).values());
        return result;
    }

    Formulario(data:any){
        this.cargarContenedorFormulario({data:data});
    }

    //Carga el contenedor con la informacion de la evaluacion
    cargarContenedorFormulario(data: {data: any}) {
        this.consulta = true;
        this.containerEvaluacion.clear();
        const factory: ComponentFactory<any> = this._cfr.resolveComponentFactory(AlumnoComponent);
        var ref: ComponentRef<any> = this.containerEvaluacion.createComponent(factory);
        ref.instance.entidad = data.data;
        //ref.instance.valores = this.Periodo;
        ref.instance.output.subscribe((cambio: boolean) => {
            this.consulta = false;
            ref.destroy();
            if (cambio) {
                this.getLista();
            }
        });
    }

    Terminar(data:any){
        this.appService.Post("evaluacionpendiente/colaborador",{"entidad":data, "evaluaciopendienteestatus":1}).then(res=>{
            if(res.status == RespuestaEstatusEnum.Success){
                this.getLista();
            }
        })
    }

}
